// Textos legales del rediseño PLR en un solo lugar, para que 1f, 2g, 3f y los resultados
// digan lo mismo. Pendiente de validación con Legal (ver docs del proyecto).

// Ley 21.719 (vigente desde el 1 de diciembre de 2026): el consentimiento tiene que ser
// específico (art. 12) y hay que informar la fuente de los datos (art. 14 ter j).

// Fuentes que se consultan con la ClaveÚnica (backend: claveUnicaHistory, data_sources):
// datos personales, CMF, SUSESO, SII, Superintendencia de Pensiones, y AFC e IPS cuando
// aplica. La misma lista se muestra en 2g, en 3f y en el consentimiento.
export const CU_SOURCES = ['SII', 'AFC', 'SUSESO', 'CMF', 'Superintendencia de Pensiones', 'IPS'];

// "No la guardamos" solo se puede prometer cuando el bloqueante 4 esté resuelto.
export const CU_NOT_STORED_CONFIRMED = false;

export const formatList = (items: string[]) => {
  if (items.length <= 1) return items.join('');
  const last = items[items.length - 1];
  // "y" pasa a "e" antes de una palabra que suena con i ("SUSESO e IPS").
  const and = /^(i|hi)(?!e)/i.test(last) ? 'e' : 'y';
  return `${items.slice(0, -1).join(', ')} ${and} ${last}`;
};

export const CU_SOURCES_TEXT = formatList(CU_SOURCES);

// 2g: segundo checkbox (autorización para usar la ClaveÚnica). Texto simplificado por Max (2 nov):
// ya no nombra las licencias médicas que trae SUSESO (dato de salud, art. 16): validar con Legal.
export const CU_CONSENT_TEXT = `Autorizo a banca.me a usar mi ClaveÚnica para consultar ${CU_SOURCES_TEXT} para evaluar mi perfil crediticio.`;

// 1f: aviso explícito, antes del CTA, de que con el RUT se consultan deudas.
// Una línea bajo "Tu RUT" (también en mobile).
export const BUREAU_NOTICE = 'Con él revisamos tus deudas y antecedentes comerciales para evaluarte.';

// 1f: fuentes externas que se consultan con el RUT, antes de la ClaveÚnica (backend:
// riskEngine.fetchData: transunion, directorio = endpoint de Experian que en realidad es Sinacofi
// (Max, 2 Nov: no se nombra Experian), sbif = Sinacofi ProRiesgo,
// delinquency = Sinacofi, alimony). Base de licitud: medidas precontractuales a solicitud
// del titular (art. 13 c), por eso es un aviso y no un checkbox (decisión de Max, 29 Oct).
// Qué se revisa y para qué lo dice BUREAU_NOTICE (bajo el RUT); aquí van solo las fuentes
// (Max, 2 Nov: sin repetir "para evaluarte" ni el detalle de Sinacofi).
export const RUT_SOURCES = [
  'TransUnion',
  'Sinacofi',
  'el Registro Nacional de Deudores de Pensiones de Alimentos',
];
export const RUT_SOURCES_NOTICE = `Fuentes consultadas: ${formatList(RUT_SOURCES)}.`;

// 3 (documentos): las liquidaciones pueden traer datos sensibles (salud, afiliación sindical),
// que requieren consentimiento expreso (art. 16).
export const DOCUMENTS_CONSENT_TEXT = 'Autorizo a banca.me a usar estos documentos, incluidos los datos de salud o afiliación sindical que aparezcan en ellos, solo para evaluar esta solicitud.';

// 1f: encuadre responsable/encargado en marca blanca.
export const controllerNotice = (partnerName: string) => (
  `${partnerName} es responsable de tus datos y banca.me los procesa por encargo suyo para esta evaluación.`
);

// 2g: quién recibe la credencial. Visible en el resumen de "Para qué usamos tu ClaveÚnica"
// y con el detalle (no la inmobiliaria) en el primer punto del desplegable.
export const CU_SUMMARY = `La recibe solo banca.me y la usamos para esta evaluación.${
  CU_NOT_STORED_CONFIRMED ? ' No la guardamos.' : ''}`;

export const cuRecipientDetail = (partnerName?: string) => (
  `${partnerName ? `, no ${partnerName}` : ''}. Con ella consultamos tus datos personales y tu información en ${CU_SOURCES_TEXT}.`
);

// 4f / 4fb / 4fc: decisión automatizada (Art. 8° bis).
// Sin proyecto con nombre (entidad "-default"), la última línea no dice "para este proyecto".
export const decisionExplanation = (hasProject = true) => [
  'Este resultado lo calcula de forma automática el sistema de evaluación de banca.me.',
  `Usa tus ingresos, cotizaciones y deudas: lo que leímos con tu ClaveÚnica (${CU_SOURCES_TEXT}) y tus antecedentes en TransUnion y Sinacofi.`,
  `Con eso estimamos cuánto podrías pagar al mes y cuánto podrías financiar${hasProject ? ' para este proyecto' : ''}.`,
];

export const HUMAN_REVIEW_MESSAGE = (project?: string) => (
  `Hola, quiero pedir que una persona revise mi evaluación${project ? ` para ${project}` : ''}.`
);

// Política de privacidad según partner (Enlace Inmobiliario tiene la suya).
export const privacyPolicyUrl = (partnerName?: string) => (
  partnerName === 'Enlace Inmobiliario'
    ? 'https://www.banca.me/recursos/legal/politica-privacidad-enlace-inmobiliario'
    : 'https://www.banca.me/recursos/legal/politica-privacidad'
);

export const termsUrl = (origin: string) => `/terms-and-conditions?origin=${encodeURIComponent(origin)}&referrer=plr`;
